/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!********************************!*\
  !*** ./scripts/pfa-checker.js ***!
  \********************************/
var pdpFormATC = document.querySelector('.product__info-wrapper form .product-form__submit');
var pfaInfo = document.querySelector('.pfas-info');
var pfasCountry = document.querySelector('.pfas-country');
var pfasRegion = document.querySelector('.pfas-state');
var pfasCountryJson, pfasRegionJson;
var ipinfo = JSON.parse(localStorage.getItem('ipinfo'));
if (document.body.contains(pfasCountry)) {
  pfasCountryJson = JSON.parse(pfasCountry.innerHTML);
}
if (document.body.contains(pfasRegion)) {
  pfasRegionJson = JSON.parse(pfasRegion.innerHTML);
}
var variantSelects = document.querySelector('variant-selects') ? document.querySelector('variant-selects') : document.querySelector('variant-radios');
variantSelects.addEventListener('change', onVariantChanged);
onVariantChanged();
function onVariantChanged() {
  var currentVariant = document.querySelector('.product-variant-id').value;
  var productPFADetail = JSON.parse(document.querySelector('[data-pfa-json]').innerHTML);
  var productPFA = Object.keys(productPFADetail).map(function (key) {
    return productPFADetail[key];
  });
  var _loop = function _loop(i) {
    if (currentVariant == productPFA[i].id) {
      Array.from(pfasCountryJson).forEach(function (country) {
        if (ipinfo.country == country) {
          Array.from(pfasRegionJson).forEach(function (state) {
            if (ipinfo.region == state) {
              //  Now check for PFA
              checkRegion(productPFA[i].pfa);
            }
          });
        }
      });
      return "break";
    }
  };
  for (var i = 0; i < productPFA.length; i++) {
    var _ret = _loop(i);
    if (_ret === "break") break;
  }
}
function checkRegion(pfa) {
  if (pfa) {
    pdpFormATC.classList.add('pfas');
    pfaInfo.classList.remove('hidden');
  } else {
    pdpFormATC.classList.remove('pfas');
    pfaInfo.classList.add('hidden');
  }
}
/******/ })()
;